<template>
  <div class="star-text">
    <div v-if="saleStar > 0 || avgStar > 0" class="star-cell">
      <i class="el-icon-star-on star-icon"></i>
      <span>{{ saleStar + '+' + avgStar }}</span>
    </div>
    <div v-else class="no-star">暂无星级</div>
  </div>
</template>

<script>
export default {
  name: 'CustomStarText',
  props: {
    saleStar: {
      type: [String, Number],
      required: false,
      default: 0
    },
    avgStar: {
      type: [String, Number],
      required: false,
      default: 0
    }
  }
}
</script>

<style scoped lang="less">
.star-cell {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding-right: 8px;
  background: linear-gradient(90deg, #FFF6EB 0%, #FFEAD0 100%);
  border-radius: 6px;
  color: #FA7000;
  font-size: 13px;

  .star-icon {
    padding: 2px 4px;
    color: #FA7000;
    font-size: 15px;
    background: linear-gradient(125deg, #FFF1DE 0%, #FFD6AD 100%);
    border-radius: 4px 0px 4px 4px;
  }
}

.no-star {
  color: #9AA0A8;
  font-size: 13px;
}

</style>
